export default palette => ({
  root: {
    borderRadius: 12,
    border: `1px solid ${palette.border}`,
  },
})
